import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const Pricing = () => {
  const plans = [
    {
      name: "Free",
      price: "0",
      desc: "Perfect for small shops just getting started.",
      features: ["Unlimited billing", "Basic inventory (100 products)", "1 user account", "Daily sales report", "Works offline"],
      button: "Download Free",
      isPopular: false
    },
    {
      name: "Pro",
      price: "299",
      desc: "For growing stores who want more features.",
      features: ["Everything in Free", "Unlimited products", "5 user accounts", "QR menu ordering", "Advanced analytics", "Customer credit management", "Auto payment reminders"],
      button: "Start Free Trial",
      isPopular: true
    }
  ];

  return (
    <section id="pricing" className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-emerald-600 font-bold uppercase tracking-widest text-sm mb-3">Pricing</h2>
          <h3 className="text-4xl font-bold text-slate-900">Simple, Affordable Pricing For Everyone</h3>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {plans.map((plan, index) => (
            <div key={index} className={`relative p-10 rounded-3xl border-2 transition-all ${plan.isPopular ? 'border-emerald-500 shadow-2xl shadow-emerald-100' : 'border-slate-100'}`}>
              {plan.isPopular && (
                <span className="absolute -top-4 left-1/2 -translate-x-1/2 bg-emerald-500 text-white px-4 py-1 rounded-full text-sm font-bold">
                  Most Popular
                </span>
              )}
              
              <h4 className="text-2xl font-bold text-slate-900 mb-2">{plan.name}</h4>
              <div className="flex items-baseline gap-1 mb-4">
                <span className="text-4xl font-black">₹{plan.price}</span>
                <span className="text-gray-500">/month</span>
              </div>
              <p className="text-gray-600 mb-8">{plan.desc}</p>
              
              <ul className="space-y-4 mb-10">
                {plan.features.map((feat, i) => (
                  <li key={i} className="flex items-center gap-3 text-slate-700">
                    <CheckCircle2 className="text-emerald-500" size={20} />
                    {feat}
                  </li>
                ))}
              </ul>

              <button className={`w-full py-4 rounded-2xl font-bold transition ${plan.isPopular ? 'bg-emerald-600 text-white hover:bg-emerald-700' : 'bg-slate-100 text-slate-900 hover:bg-slate-200'}`}>
                {plan.button}
              </button>
            </div>
          ))}
        </div>
        <p className="text-center text-gray-500 mt-8">7-day money back guarantee on Pro plan</p>
      </div>
    </section>
  );
};

export default Pricing;